import { render, staticRenderFns } from "./billPriceTile.vue?vue&type=template&id=363a31d1&"
import script from "./billPriceTile.vue?vue&type=script&lang=js&"
export * from "./billPriceTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports